import $ from 'jquery';
import dt from 'datatables.net-dt';
import dtFixedHead from 'datatables.net-fixedheader-dt';
import dtResponsive from 'datatables.net-responsive-dt';
import Item from '../api/item.js';

import ModalHelper from '../modules/modal-helpers';
const modalHelper = new ModalHelper();

import TemplateHelper from '../modules/template-helper';
const templateHelper = new TemplateHelper();

dt();
dtFixedHead();
dtResponsive();

import SvgIcons from '../modules/svgicons';
const svgIcons = new SvgIcons();

const icons = {
  error: svgIcons('error', 'status--error'),
  warn: svgIcons('warning', 'status--warn'),
  complete: svgIcons('check', 'status--complete'),
  not_available: svgIcons('clear', 'status--not_available'),
  inactive: svgIcons('clear', 'status--inactive'),
  chat: svgIcons('chat'),
  locked: svgIcons('locked')
};

const StatusLabels = {
  error: '🚫',
  warn: '⚠️',
  complete: '✅',
  not_available: '✖️',
  inactive: '✖'
}

class ItemListing {
  constructor() {
    if(!document.querySelector('.page--main-listing,.page--archive')) return;
    this.shouldUseServerside = document.querySelector('table.serverside');
    this.dtSelector = '.datatable';
    this.modalTemplate = 'modal-box';
    this.commentTemplate = 'quote-box';
    this.init();
  }

  init() {
    const {mainListView} = window;
    if(!mainListView) return;

    $.fn.dataTableExt.oStdClasses.sSortAsc = 'sorting--asc';
    $.fn.dataTableExt.oStdClasses.sSortDesc = 'sorting--desc';
    $.fn.dataTableExt.oStdClasses.sSortColumn = 'sorting--';
    $.fn.dataTableExt.oStdClasses.sSortable = 'sorting';

    const columns = mainListView.columns.map(col => ({
      ...col,
      // Blockify headers, so that selects will wrap below.
      title: `<div>${ col.title }</div>`,
      render: this.renderCell(col)
    }));

    const self = this;
    this.$dtContainer = $(this.dtSelector);
    const ajaxOptions = {
      url: '/api/1.0.0/items/get-list',
      type: 'POST',
      contentType: 'application/json',
      error: function(xhr, error, thrown) {
        if (xhr.status === 401) {
          alert('Kirjaudu sisään ERP:iin nähdäksesi listauksen.');
        }
        else {
          alert('Virhe: ' + thrown);
        }
      },
      data: function(d) {
        const clientSelect = document.querySelector('#filterClient');
        if (clientSelect && clientSelect.value) {
          d.client = clientSelect.value;
        }
        const warehouseSelect = document.querySelector('#filterWarehouse');
        if (warehouseSelect && warehouseSelect.value) {
          d.warehouse = warehouseSelect.value;
        }
        d.item_archived = mainListView.item_archived;
        return JSON.stringify(d);
      },
    };

    const dtOptions = {
      serverSide: Boolean(this.shouldUseServerside),
      ajax: this.shouldUseServerside ? ajaxOptions : null,
      data: this.shouldUseServerside ? undefined : mainListView.data,
      searchDelay: this.shouldUseServerside ? 600 : undefined, // This is not a debounce but a request repeat throttle, so not completely ideal. Debounce needs a DataTables version upgrade.
      columns,
      orderClasses: false,
      deferRender: true,
      autoWidth: true,
      ordering: true,
      fixedHead: true,
      responsive: false,
      searching: true,
      scrollX: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: 0, // save state for indefinite duration (-1 for sessionStorage, >=0 for localStorage)
      language: window.tabularDataTranslations || {},
      search: {
        regex: false
      },
      paging: true,
      scrollY: '70vh', // Creates a scroll container
      lengthMenu: this.shouldUseServerside ? [[25,100,250], ['25','100','250']] : [[25, 100, -1], ['25', '100', 'Kaikki']],
      pageLength: 25, // Default lengthMenu selection
      info: true, // Show result counts ("kohteet 1 - 25 / 65")
      order: [[9, 'desc']],
      columnDefs: [{
        'defaultContent': '-',
        'targets': '_all'
      },
      {
        targets: [8],
        orderData: [9],
      }
      ],
      initComplete: function() { self.postInit(this); },
    };

    this.dt = this.$dtContainer.DataTable(dtOptions);

    const clearButton = document.querySelector('.clear-datatable-settings');
    if(clearButton) clearButton.addEventListener('click', () => this.resetSavedSettings());

    // Handle comment buttons
    $('.dataTables_scrollBody').on('click', 'button[data-show-comments]', async event => {
      const button = event.currentTarget;
      const comments = await this.fetchComments(button.dataset.showComments, button.dataset.prestorage);
      if(comments.length) {
        this.createCommentModal(comments, button.dataset.showComments);
      }
    })
  }

  /**
   * Gets a list of important comments via the API, for a single item
   * @param {Number|String} itemPid - The pid of the item
   * @param {Boolean} prestorage - If true, fetches all comments, otherwise only important ones
   * @returns {Array} - List of comments
   */
  async fetchComments(itemPid, prestorage = false) {
    const item = new Item(itemPid);
    const response = await item.getComments();
    if(response.status !== 'OK') return;

    if(prestorage === 'true') {
      return response.result;
    } else {
      return response.result.filter(comment => comment.important);
    }
  }

  /**
   * Creates and displays a modal, containing the given comments
   * @param {Array} comments - List of comments to display within the modal
   * @param {number} itemPid - The pid of the item whose comments we're showing.
   */
  createCommentModal(comments, itemPid) {
    const modalView = {
      // TODO: Get translations via Stage
      modalName: itemPid,
      title: comments.length > 1 ? 'Uudet tärkeät viestit' : 'Uusi tärkeä viesti',
      closeText: 'Sulje',

      initiallyOpen: true,
      contents: comments.map(comment => {
        const commentView = {
          author: comment.user,
          date: comment.created_timestamp,
          dateFormatted: comment.created_time,
          important: comment.important,
          seen: comment.seen,
          commentId: comment.pid,
          content: comment.comment
        };
        return templateHelper.render(
          this.commentTemplate,
          commentView,
          null, 'none'
        )
      }).join('')
    };

    templateHelper.render(
      this.modalTemplate,
      modalView,
      document.body, 'append'
    );

    modalHelper.lockScrolling();
    modalHelper.bindEsc();
  }

  /**
   * Clears all stored DataTables user settings from localStorage
   */
  resetSavedSettings() {
    this.dt.state.clear();
    // Remove url params and trigger a refresh:
    location.replace(location.href.split('?')[0])
  }

  /**
   * Creates a custom renderer for the given column.
   * @param {Object} col - The column configuration object
   * @returns {Function} - A render function for dataTables (https://datatables.net/reference/option/columns.render#function)
   *   @params {*} data - Generally unused, since data is loaded from custom JS object
   *   @params {String} type - The requested render type (filter/display/type/sort)
   *   @params {*} row - The row data
   */
  renderCell(col) {
    /* For sanitizing data against injections */
    const escape = (val) => {
      if (val === null || val === undefined) return '';
      return $.fn.dataTable.render.text().display(val);
    };
    return function (data,type,row) {
      if(type === 'display') {
        switch (col.className) {
          case 'date':
            return `<div class="value">${escape(row[col.fields[0]].display || data || '-')}</div>`;
          case 'comment':
            return row.unseen_important || row.has_pre_storage_event === '1'
              ? `<button class="button button--small button--icon-button" data-prestorage=${row.has_pre_storage_event === '1' ? true : false} data-show-comments="${row.pid}">${icons.chat}</button>`
              : '';
          case 'itemLink':
            if(row.tooltip) {
              return `<div class="value"><a href="${row.url}" title="${row.tooltip}">${row.pid} ${icons.locked}</a></div>`
            }
            return `<a href="${row.url}">${row.has_pre_storage_event === '1' ? row.storage_event_pid : row.pid}</a>`;
          case 'status':
            return icons[row[col.fields[0]]] || '-';
          default:
            return `<div class="value">${escape(row && row[col.fields[0]] || data || '-')}</div>`;
        }
      }
      else if(type === 'sort') {
        if(col.className === 'date') {
          return row[col.fields[0]].sort;
        }
        if(col.className === 'comment') {
          return row[col.fields[1]];
        }
        return row[col.fields[0]];
      }
      else if(type === 'filter') {
        if(col.className === 'date') {
          return row[col.fields[0]].display;
        }
        return row[col.fields[0]];
      }
      else {
        if(col.className === 'date') {
          return row[col.fields[0]].display;
        }
        return row[col.fields[0]];
      }
    }
  }


  /**
   * DataTables post initialization actions
   * @param {Object} dataTable - the DataTable instance
   */
  postInit(dataTable) {
    const self = this;
    const savedState = dataTable.api().state();

    // Create filter UI
    dataTable.api().columns().every(function(columnIndex) {
      const columnData =  window.mainListView.columns[columnIndex];

      if(columnData && ['status', 'filter'].includes(columnData.className)) {
        self.createColumnFilter(this, columnIndex, savedState, columnData);
      }
    });

    // Enable client and warehouse filters for server-side.
    if (this.shouldUseServerside) {
      const clientFilterSelect = document.querySelector('#filterClient');
      const warehouseFilterSelect = document.querySelector('#filterWarehouse');
      [clientFilterSelect, warehouseFilterSelect].forEach(sel => {
        if (sel) {
          sel.addEventListener('change', e => {
            dataTable.api().draw();
          });
        }
      });
    }

    // show table content and header row:
    $(this.dtSelector).addClass('paging');

    this.moveControls();

    $('.spinner').hide();
    $(this.dtSelector).show();

    // Queue a widths recalculation
    // Doesn't always work without the timeout
    setTimeout(() => {
      dataTable.api().columns.adjust();
    }, 100);
  }

  /**
   * Moves Datatables' controls into same container with filters
   */
  moveControls() {
    const targetContainer = document.getElementById('listing-search-container');
    const filterContainer = document.querySelector('.dataTables_filter');
    const filterLabel = filterContainer.querySelector('label');
    const filterInput = filterContainer.querySelector('input');
    targetContainer.appendChild(filterContainer);
    filterContainer.appendChild(filterInput);
    filterLabel.classList.add('text-input__label');
    filterInput.classList.add('text-input__input');
  }

  /**
   * Creates a dropdown filter for the given Datatable column
   *
   * @param {Object} column - The DataTable column
   * @param {Number} columnIndex -
   * @param {Object} savedState - Saved user settings for DataTable
   * @param {Object} columnData -
   */
  createColumnFilter(column, columnIndex, savedState, columnData) {
    const isServerSide = this.shouldUseServerside;

    // 1. Create filter dropdown
    const $select = $('<select><option value="">…</option></select>');
    $select.appendTo($(column.header()))
      .on('change', function() {
        const val = $select.val();
        if (isServerSide) {
          // Server-side: Send literal value
          column.search(val).draw();
        } else {
          // Client-side: Send regex for exact match
          const escapedValue = $.fn.dataTable.util.escapeRegex(val);
          column.search(escapedValue ? `^${escapedValue}$` : '', true, false).draw();
        }
      })
      .on('click', event => event.stopPropagation());

    // 2. Handle Saved State
    const savedSearchString = savedState.columns[columnIndex].search.search;
    // If server-side, savedSearchString is literal. If client-side, it's a regex like ^Value$
    const normalizedSavedValue = isServerSide 
      ? savedSearchString 
      : savedSearchString.replace(/^\^|\$$/g, '');

    // 3. Determine which list of options to use
    let options = [];

    // Server-side logic relies on window.mainListView.filter_options,
    // which specifies which states are relevant for the current view / user.
    if (isServerSide) {
      // This retrieves the 'name' property defined in the DataTable column's settings.
      const columnName = column.settings()[0].aoColumns[columnIndex].sName;
      options = window.mainListView.filter_options[columnName];

    // Client-side logic populates filters by identifying unique values for each column.
    } else {
      // Find unique values from local data for client-side
      options = window.mainListView.data.reduce((acc, row) => {
        const value = row[columnData.fields[0]];
        if (value !== undefined && value !== null && !acc.includes(value)) {
          acc.push(value);
        }
        return acc;
      }, []).sort();
    }

    // 4. Populate the dropdown
    options.forEach(val => {
      const value = val || '';
      const label = StatusLabels[value] || value;
      const isSelected = value === normalizedSavedValue ? 'selected' : '';
      
      $select.append(`<option value="${value}" ${isSelected}>${label}</option>`);
    });
  }
}

export default ItemListing;
export { ItemListing };
